import React from 'react';
import type { FC } from 'react';
import type { TableCellProps } from '@mui/material';
import { Typography, Stack, Chip, TableCell } from '@mui/material';

interface VersionCellProps extends TableCellProps {
  version: string;
  isLatest: boolean;
}

export const VersionCell: FC<VersionCellProps> = ({
  version,
  isLatest,
  ...props
}) => {
  return (
    <TableCell component='th' scope='row' {...props}>
      <Stack direction='row' spacing={1}>
        <Typography>{version}</Typography>
        {isLatest && <Chip color='primary' label='latest' size='small' />}
      </Stack>
    </TableCell>
  );
};
